export const TIME_PERIOD = {
    MONTH: 'month',
    YEAR: 'year',
};
